/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type EventRequestCreateVariables = Types.Exact<{
  fullAddress: Types.Scalars['String']
  startAt: Types.Scalars['DateTime']
  endAt: Types.Scalars['DateTime']
  eventType: Types.Scalars['String']
  vendingInstructions: Types.InputMaybe<Types.Scalars['String']>
  peopleEstimated: Types.Scalars['Int']
  creationNote: Types.InputMaybe<Types.Scalars['String']>
  spots: Types.Scalars['Int']
  foodPreferences: Types.InputMaybe<Types.Scalars['String']>
  preferredTruckId: Types.InputMaybe<Types.Scalars['Int']>
  organizationId: Types.InputMaybe<Types.Scalars['Int']>
}>

export type EventRequestCreate = {
  __typename: 'Root'
  eventsRequestCreate: {
    __typename: 'EventsRequestCreatePayload'
    eventsRequest: { __typename: 'EventsRequest'; id: number } | null
    errors: Array<{
      __typename: 'UserError'
      fullMessage: string | null
      key: string | null
      message: string | null
      data: string | null
    }> | null
  } | null
}

export const EventRequestCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EventRequestCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'fullAddress' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'startAt' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DateTime' }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'endAt' }
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'DateTime' }
            }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'eventType' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'vendingInstructions' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'peopleEstimated' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'creationNote' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'spots' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'foodPreferences' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'preferredTruckId' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'organizationId' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventsRequestCreate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fullAddress' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'fullAddress' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startAt' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'startAt' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endAt' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'endAt' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventType' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'eventType' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vendingInstructions' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'vendingInstructions' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'peopleEstimated' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'peopleEstimated' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'creationNote' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'creationNote' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'spots' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'spots' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'foodPreferences' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'foodPreferences' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'preferredTruckId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'preferredTruckId' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'organizationId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'organizationId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventsRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'data' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type EventRequestCreateMutationFn = Apollo.MutationFunction<
  EventRequestCreate,
  EventRequestCreateVariables
>

/**
 * __useEventRequestCreate__
 *
 * To run a mutation, you first call `useEventRequestCreate` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventRequestCreate` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventRequestCreate, { data, loading, error }] = useEventRequestCreate({
 *   variables: {
 *      fullAddress: // value for 'fullAddress'
 *      startAt: // value for 'startAt'
 *      endAt: // value for 'endAt'
 *      eventType: // value for 'eventType'
 *      vendingInstructions: // value for 'vendingInstructions'
 *      peopleEstimated: // value for 'peopleEstimated'
 *      creationNote: // value for 'creationNote'
 *      spots: // value for 'spots'
 *      foodPreferences: // value for 'foodPreferences'
 *      preferredTruckId: // value for 'preferredTruckId'
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useEventRequestCreate(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EventRequestCreate,
    EventRequestCreateVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    EventRequestCreate,
    EventRequestCreateVariables
  >(EventRequestCreateDocument, options)
}
export type EventRequestCreateHookResult = ReturnType<
  typeof useEventRequestCreate
>
export type EventRequestCreateMutationResult =
  Apollo.MutationResult<EventRequestCreate>
export type EventRequestCreateMutationOptions = Apollo.BaseMutationOptions<
  EventRequestCreate,
  EventRequestCreateVariables
>
